import { sendPubSubEvent } from '../api';

export const articleClicked = async (article = {}) => {
  if (!article) {
    return;
  }

  await sendPubSubEvent('user.clicked.article', {
    id: article.id,
    shortId: article.shortId,
  });
};

export const articleVisited = async (article = {}) => {
  if (!article) {
    return;
  }
  const articleVisit = article.categoryNames[article.categoryNames.length - 2];
  await sendPubSubEvent('user.visited.article', {
    id: article.id,
    shortId: article.shortId,
    categoryNames: article.categoryNames,
    category: articleVisit,
  });
};
